export {
  type GraphemeCompoundsData,
  graphemeCompoundsDataTable,
} from "#grapheme-compounds-data-table";
